var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.983 8.99167V12.325C14.983 12.5417 14.9747 12.75 14.9497 12.95C14.758 15.2 13.433 16.3167 10.9913 16.3167H10.658C10.4497 16.3167 10.2496 16.4167 10.1246 16.5833L9.12466 17.9167C8.683 18.5083 7.96632 18.5083 7.52465 17.9167L6.52464 16.5833C6.41631 16.4417 6.17466 16.3167 5.99132 16.3167H5.65799C2.99966 16.3167 1.66632 15.6583 1.66632 12.325V8.99167C1.66632 6.55001 2.79133 5.22501 5.03299 5.03334C5.23299 5.00834 5.44133 5 5.65799 5H10.9913C13.6497 5 14.983 6.33334 14.983 8.99167Z",
    stroke: "#121212",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3167 5.65836V8.9917C18.3167 11.4417 17.1917 12.7584 14.95 12.95C14.975 12.75 14.9834 12.5417 14.9834 12.325V8.9917C14.9834 6.33336 13.65 5.00002 10.9917 5.00002H5.65839C5.44172 5.00002 5.23339 5.00836 5.03339 5.03336C5.22505 2.79169 6.55005 1.66669 8.99172 1.66669H14.325C16.9834 1.66669 18.3167 3.00003 18.3167 5.65836Z",
    stroke: "#121212",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2462 11.0417H11.2537",
    stroke: "#121212",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3296 11.0417H8.3371",
    stroke: "#121212",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41292 11.0417H5.42042",
    stroke: "#121212",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesIcon);
export default __webpack_public_path__ + "static/media/messages-icon.0b009c10008f90dfcc7ec61c969a0f4d.svg";
export { ForwardRef as ReactComponent };